import { render, staticRenderFns } from "./FulfillmentAdd.vue?vue&type=template&id=180f15d5&scoped=true&"
import script from "./FulfillmentAdd.vue?vue&type=script&lang=js&"
export * from "./FulfillmentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180f15d5",
  null
  
)

export default component.exports